import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "react-toastify/dist/ReactToastify.css"
import { App } from "@/App"
import "@/localization"
import "@/styles/index.scss"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
